import React, { useState, useEffect } from 'react';
import { DropDownComponent, InputComponent, TextAreaComponent, FileUploadComponent } from '../custcomponents';
import { useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { AxiosAdminInstance } from '../utils';
import { validate } from '../validatorutil';
const FilterComponent = ({ filterText, onFilter, onClear, onExport }) => (
    <>
        <input
            id="search"
            type="text"
            placeholder="Filter Any"
            aria-label="Search Input"
            value={filterText}
            onChange={onFilter}
        />
        <a href="#" onClick={onClear}>
            X
		</a>
        <button onClick={onExport} style={{ marginLeft: '10px' }}>
            Export to CSV
        </button>
    </>
);

// Main Event Component (Handles State)
const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast('Copied!');
};

const exportToCSV = (data) => {
    if (data.length === 0) {
        toast.error('No data to export');
        return;
    }
    const headers = Object.keys(data[0]).join(',');
    const rows = data.map(row => Object.values(row).map(val => `"${val}"`).join(',')).join('\n');
    const csv = `${headers}\n${rows}`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'coupons.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    toast('CSV exported successfully');
};

export const ManageCoupons = () => {
    const { eventcode } = useParams();
    const [reloadList, setReloadList] = useState(false);
    const [loading, setLoading] = useState(false);
    const [couponsListresp, setCouponsListresp] = useState([] as any);
    const [eventDetailsresp, setEventDetailsresp] = useState([] as any);
    const [ipcouponcode, setIpcouponcode] = useState('' as any);
    const [ipdiscountvalue, setIpdiscountvalue] = useState('' as any);
    const [ipdiscounttype, setIpdiscounttype] = useState('' as any);
    const [ipdiscountstartdate, setIpdiscountstartdate] = useState('' as any);
    const [ipdiscountendate, setIpdiscountendate] = useState('' as any);
    const [ipmaxusage, setIpmaxusage] = useState('1' as any);
    const [ippasstype, setIppasstype] = useState('' as any);
    const [ipcouponstatus, setIpcouponstatus] = useState('' as any);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const { data: response } = await AxiosAdminInstance.get('/api/admin/getcoupons?eventcode=' + eventcode);
            console.log(response);
            if (response.result != "Success" || response.data?.length == 0) {
                setCouponsListresp([]);
                setLoading(false);
                return;
            }
            setCouponsListresp(response.data);
            setLoading(false);
        }
        const fetchEventData = async () => {
            setLoading(true);
            const { data: response } = await AxiosAdminInstance.get('/api/admin/getevent?eventcode=' + eventcode);
            console.log(response);
            if (response.result != "Success" || response.data?.length == 0) {
                setEventDetailsresp([]);
                setLoading(false);
                return;
            }
            setEventDetailsresp(response.data[0]);
            setLoading(false);
        }
        fetchData();
    }, [reloadList]);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const { data: response } = await AxiosAdminInstance.get('/api/admin/getevent?eventcode=' + eventcode);
            console.log(response);
            if (response.result != "Success" || response.data?.length == 0) {
                setEventDetailsresp([]);
                setLoading(false);
                return;
            }
            setEventDetailsresp(response.data[0]);
            setLoading(false);
        }
        fetchData();
    }, []);
    const listcouponcolumns = [
        {
            name: 'Edit',
            cell: row => (
                <a href="#" onClick={(e) => { onClickEditCouponStatus(e, row.couponcode) }}>
                    Edit Status
                </a>
            ),
            sortable: false,
        },
        {
            name: 'couponcode',
            cell: row => (
                <span>
                    {row.couponcode} <i className="fa fa-copy" onClick={() => copyToClipboard(row.couponcode)} style={{cursor: 'pointer'}}></i>
                </span>
            ),
            sortable: true,
            grow: 4,
            reorder: true,
            wrap: true,
        }, {
            name: 'Discount',
            selector: row => row.discount,
            sortable: true,
            reorder: true,
            wrap: true,
        },
        {
            name: 'Discount Type',
            selector: row => row.discounttype,
            sortable: true,
            wrap: true,
        }, {
            name: 'Ticket Type',
            selector: row => row.passtype,
            sortable: true,
            wrap: true,
        }, {
            name: 'Maxusage',
            selector: row => row.maxusage,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Used Count',
            selector: row => row.usedCount,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Reserved Count',
            selector: row => row.reservedCount,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Exhausted',
            selector: row => row.exhausted ? 'Yes' : 'No',
            sortable: true,
            wrap: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            wrap: true,
        },
        {
            name: 'startdate',
            selector: row => row.startdate,
            sortable: true,
            wrap: true,
        },
        {
            name: 'enddate',
            selector: row => row.enddate,
            sortable: true,
            wrap: true,
        },
        {
            name: 'GeneratedBy',
            selector: row => row.generatedby,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Clientorderid',
            selector: row => row.clientorderid,
            sortable: true,
            wrap: true,
        }

    ];
    const onClickEditCouponStatus = (e, couponcode) => {
        e.preventDefault();
        const coupon = couponsListresp.find(c => c.couponcode === couponcode);
        if (coupon) {
            if (coupon.status === 'REDEEMED') {
                toast.error('Cannot edit a redeemed coupon.');
                return;
            }
            setIsEditing(true);
            setIpcouponcode(coupon.couponcode || '');
            setIpdiscountvalue(String(coupon.discount || ''));
            setIpdiscounttype(coupon.discounttype || '');
            setIpdiscountstartdate(coupon.startdate || '');
            setIpdiscountendate(coupon.enddate || '');
            setIpmaxusage(String(coupon.maxusage || ''));
            setIppasstype(coupon.passtype || '');
            setIpcouponstatus(coupon.status || '');
        }
    }



    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = couponsListresp.filter(
        item => (item.clientorderid && item.clientorderid.toLowerCase().includes(filterText.toLowerCase()) || item.couponcode && item.couponcode.toLowerCase().includes(filterText.toLowerCase())
            || item.discounttype && item.discounttype.toLowerCase().includes(filterText.toLowerCase())
            || item.passtype && item.passtype.toLowerCase().includes(filterText.toLowerCase())
            || item.status && item.status.toLowerCase().includes(filterText.toLowerCase())),
    );

    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        const handleExport = () => {
            exportToCSV(filteredItems);
        };

        return (
            <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} onExport={handleExport} />
        );
    }, [filterText, resetPaginationToggle, filteredItems]);
    const onClickAutoGenrateCoupon = async (e: any) => {
        e.preventDefault();
        const { data: response } = await AxiosAdminInstance.get('/api/admin/generatecoupon?eventcode=' + eventcode);
        console.log(response);
        if (response.result != "Success" || !response.coupon) {
            toast.error('Unable to Auto Generate Coupon');
            setIpcouponcode('');
            return;
        }
        setIpcouponcode(response.coupon);
    }
    const onClickAddEvent = async (e: any) => {
        e.preventDefault();

        if (!ipmaxusage || isNaN(Number(ipmaxusage)) || (Number(ipmaxusage) <= 0 && Number(ipmaxusage) !== -1)) {
            toast.error('Max Usage must be a number greater than 0 or -1');
            return;
        }

        if (!validate('Coupon Code', ipcouponcode, 'none', false, 'txtcouponcode') || !validate('Discount Value', ipdiscountvalue, 'discount', false, 'txtdiscountvalue')
            || !validate('Discount Type', ipdiscounttype, 'none', false, 'txtDicountType') || !validate('Ticket Type', ippasstype, 'none', false, 'txtidvtickettype')
            || !validate('Coupon Status', ipcouponstatus, 'none', false, 'txtCouponstatus')
            || !validate('Coupon Start Date', ipdiscountstartdate, 'date', true, 'txtdiscountstarttime')
            || !validate('Coupon End Date', ipdiscountendate, 'date', true, 'txtdiscountendtime')
        ) {

            return;
        }
        setSubmitLoading(true);
        let evtObj: any = {
            eventcode: eventcode,
            discount: ipdiscountvalue,
            discounttype: ipdiscounttype,
            maxusage: ipmaxusage,
            status: ipcouponstatus,
            passtype: ippasstype,
            couponcode: ipcouponcode,
            startdate: ipdiscountstartdate,
            enddate: ipdiscountendate
        }

        try {
            const { data: response, status: statuscode, } = await AxiosAdminInstance.post('/api/admin/savecoupons', evtObj);
            if (response.result == "Success") {
                toast("Success.");
                setReloadList(true);
                setSubmitLoading(false);
                onClickResetEvent(null);
            }
            else {
                toast.error(response.msg);
                setSubmitLoading(false);

            }
        } catch (error: any) {
            console.log(error.status);
            setSubmitLoading(false);
        }

    }
    const onClickResetEvent = (e: any) => {
        if (e) {
            e.preventDefault();

        }
        setIsEditing(false);
        setIpcouponcode('');
        setIpdiscountvalue('');
        setIppasstype('');
        setIpmaxusage('');
        setIpcouponstatus('');
        setIpdiscounttype('');
        setIpdiscountstartdate('');
        setIpdiscountendate('');
    }
    return (
        <>

            <section className="register-sec sec-padding-admin">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">LIST Coupons</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details">

                        <form>
                            <div className="row pt-2">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <a href="#">Add New Coupon</a>
                                </div>
                            </div>
                            <div className="row pt-2">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <DataTable
                                        columns={listcouponcolumns}
                                        data={filteredItems}
                                        progressPending={loading}
                                        striped={true}
                                        pagination
                                        subHeader
                                        subHeaderComponent={subHeaderComponentMemo}
                                        customStyles={{
                                            headCells: {
                                                style: {
                                                    whiteSpace: 'normal',
                                                },
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </form>


                    </div> {/* <!--register-sec-details end--> */}
                </div>
            </section>

            <section className="register-sec pb-3" data-scroll-index="8">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-star fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">Add Coupon</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details ">
                        <form>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <InputComponent custname="couponCode" custid="txtcouponcode" custplaceholder="Coupon Code" onExternalValue={setIpcouponcode} onExternalBind={ipcouponcode} readonly={isEditing} />
                                    {!isEditing && <a href="#" onClick={(e) => onClickAutoGenrateCoupon(e)}>Auto Generate Coupon<i className="fa fa-solid  fa-magic"></i></a>}
                                    <InputComponent custname="DiscountValue" custid="txtdiscountvalue" custplaceholder="Discount Value" onExternalValue={setIpdiscountvalue} onExternalBind={ipdiscountvalue} readonly={isEditing} />
                                    <DropDownComponent names={["percentage"]} custname="DiscountType" custid="txtDicountType" custplaceholder="Discount Type" externalstateValue={ipdiscounttype} onExternalValue={setIpdiscounttype} readonly={isEditing} />
                                    <InputComponent custname="MaxUsage" custid="txtMaxUsage" custplaceholder="Max Usage" onExternalValue={setIpmaxusage} onExternalBind={ipmaxusage} readonly={isEditing} />
                                    

                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <DropDownComponent names={eventDetailsresp.tickettypes != null ? [...Object.keys(eventDetailsresp.tickettypes), 'Any'] : []} custname="IdvTicketType" custid="txtidvtickettype" custplaceholder="Ticket Type" onExternalValue={setIppasstype} externalstateValue={ippasstype} readonly={isEditing} />
                                    <DropDownComponent names={["NEW","CANCELLED"]} custname="CouponStatus" custid="txtCouponstatus" custplaceholder="Coupon Status" externalstateValue={ipcouponstatus} onExternalValue={setIpcouponstatus} />
                                    <InputComponent custname="DiscountStarttime" custid="txtdiscountstarttime" custplaceholder="Discount Start Date (DD-MMM-YYYY)" onExternalValue={setIpdiscountstartdate} onExternalBind={ipdiscountstartdate} />
                                    <InputComponent custname="DiscountEndtime" custid="txtdiscountendtime" custplaceholder="Discount End Date (DD-MMM-YYYY)" onExternalValue={setIpdiscountendate} onExternalBind={ipdiscountendate} />

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <small>Supported Values, -1 is unlimited and {'>'}0.</small>
                                    <div className="form-field text-center" >
                                        <button type="submit" disabled={submitLoading} className="btn-default" onClick={(e) => onClickAddEvent(e)} >SAVE  {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-field text-center" >
                                        <button type="submit" disabled={submitLoading} className="btn-default" onClick={(e) => onClickResetEvent(e)} >RESET  {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div> {/* <!--register-sec-details end--> */}
                </div>
            </section>
        </>
    );
}
